import React from 'react'
import { InternetStyle } from './Internet.styled'


const Internet = () => {
  return (

     <InternetStyle>

        <i className="bi bi-wifi-off"></i> No internet Connection
    </InternetStyle>
  )
}

export default Internet;


